/* PM ARMRA Motion â€” scroll reveals, parallax y marquee para Pulse Medical */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('pm-motion');
  if (reduced) return;

  // Parallax solo en desktop: bajo 861px lo apagamos para no gastar baterÃ­a/CPU.
  var desktopMQ = window.matchMedia('(min-width: 861px)');
  function parallaxEnabled() { return desktopMQ.matches; }

  /* ---------- Reveal on scroll ---------- */
  var REVEAL_GROUPS = [
    '.pm-armra-proof__label',
    '.pm-armra-innovation__intro > *',
    '.pm-armra-innovation__cards article',
    '.pm-armra-routine__intro > div',
    '.pm-armra-routine__product',
    '.pm-armra-routine__steps article',
    '.pm-armra-bundle__media',
    '.pm-armra-bundle__offer > *',
    '.pm-armra-benefits__intro',
    '.pm-armra-benefits__copy',
    '.pm-armra-benefits__item',
    '.pm-armra-science__media',
    '.pm-armra-science__copy > *',
    '.pm-armra-testimonials__header > *',
    '.pm-armra-testimonials__card',
    '.pm-armra-products__header > *',
    '.pm-armra-products__card',
    '.pm-armra-faq__intro > *',
    '.pm-armra-faq__items details'
  ];

  var revealObserver = null;
  var pendingReveals = [];

  function revealFallbackCheck() {
    if (!pendingReveals.length) return;
    var vh = window.innerHeight;
    pendingReveals = pendingReveals.filter(function (el) {
      if (el.classList.contains('pm-in')) return false;
      var rect = el.getBoundingClientRect();
      if (rect.top < vh * 0.92 && rect.bottom > 0) {
        el.classList.add('pm-in');
        return false;
      }
      return true;
    });
  }

  function setupReveals(root) {
    if (!('IntersectionObserver' in window)) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('pm-in');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }
    REVEAL_GROUPS.forEach(function (selector) {
      var nodes = (root || document).querySelectorAll(selector);
      var groupIndex = 0;
      Array.prototype.forEach.call(nodes, function (el) {
        if (el.hasAttribute('data-pm-reveal')) return;
        // No ocultar nada que ya este dentro del viewport inicial (LCP safe)
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) {
          return;
        }
        el.setAttribute('data-pm-reveal', '');
        el.style.setProperty('--pm-reveal-delay', Math.min(groupIndex, 6));
        groupIndex += 1;
        revealObserver.observe(el);
        pendingReveals.push(el);
      });
    });
  }

  /* ---------- Parallax ---------- */
  var PARALLAX_SELECTORS = [
    '.pm-armra-innovation__image',
    '.pm-armra-science__media',
    '.pm-armra-bundle__media',
    '.pm-armra-routine__product'
  ];
  var parallaxItems = [];
  var parallaxTicking = false;

  function collectParallax(root) {
    PARALLAX_SELECTORS.forEach(function (selector) {
      var nodes = (root || document).querySelectorAll(selector);
      Array.prototype.forEach.call(nodes, function (el) {
        var media = el.querySelector(':scope > img, :scope > video');
        if (!media || el.classList.contains('pm-parallax')) return;
        el.classList.add('pm-parallax');
        parallaxItems.push(el);
      });
    });
  }

  function updateParallax() {
    parallaxTicking = false;
    if (!parallaxItems.length) return;
    if (!parallaxEnabled()) {
      // En mobile dejamos el media en su posiciÃ³n neutra una sola vez.
      parallaxItems.forEach(function (el) {
        el.style.setProperty('--pm-parallax', '0');
      });
      return;
    }
    var vh = window.innerHeight;
    var maxShift = Math.min(vh * 0.045, 46);
    parallaxItems.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -80 || rect.top > vh + 80) return;
      var center = rect.top + rect.height / 2;
      var progress = (center - vh / 2) / (vh / 2 + rect.height / 2); // -1..1
      el.style.setProperty('--pm-parallax', (progress * maxShift).toFixed(1));
    });
  }

  function onScroll() {
    revealFallbackCheck();
    if (progressBar && !progressTicking) {
      progressTicking = true;
      window.requestAnimationFrame(updateProgress);
    }
    // No agendar trabajo de parallax si no hay items o estamos en mobile.
    if (!parallaxItems.length || !parallaxEnabled()) return;
    if (!parallaxTicking) {
      parallaxTicking = true;
      window.requestAnimationFrame(updateParallax);
    }
  }

  /* ---------- Firma Pulse: polvo en el hero ---------- */
  function setupPowder(root) {
    var hero = (root || document).querySelector('.pm-armra-hero');
    if (!hero || hero.querySelector('.pm-powder')) return;
    var canvas = document.createElement('canvas');
    canvas.className = 'pm-powder';
    canvas.setAttribute('aria-hidden', 'true');
    hero.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, parts = [];
    // rosa maqui, celeste y blanco: el polvo de la marca
    var COLORS = ['232,93,138', '22,198,242', '255,255,255'];

    function size() {
      W = hero.clientWidth;
      H = hero.clientHeight;
      canvas.width = W * dpr;
      canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function make() {
      var n = W < 761 ? 22 : 44;
      parts = [];
      for (var i = 0; i < n; i++) {
        parts.push({
          x: Math.random() * W,
          y: Math.random() * H,
          r: Math.random() * 2.1 + 0.6,
          s: Math.random() * 0.32 + 0.1,
          ph: Math.random() * 6.28,
          c: COLORS[i % 3],
          a: Math.random() * 0.3 + 0.12
        });
      }
    }
    var running = false, raf = 0;
    function tick() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      var t = performance.now() / 1000;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y += p.s;
        p.x += Math.sin(t * 0.7 + p.ph) * 0.14;
        if (p.y > H + 4) { p.y = -4; p.x = Math.random() * W; }
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, 6.283);
        ctx.fillStyle = 'rgba(' + p.c + ',' + p.a + ')';
        ctx.fill();
      }
      raf = window.requestAnimationFrame(tick);
    }
    function start() { if (!running) { running = true; tick(); } }
    function stop() { running = false; window.cancelAnimationFrame(raf); }

    size();
    make();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }).observe(hero);
    } else {
      start();
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else {
        var r = hero.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) start();
      }
    });
    window.addEventListener('resize', function () { size(); make(); }, { passive: true });
  }

  /* ---------- Marquee proof strip ---------- */
  function setupMarquee(root) {
    var containers = (root || document).querySelectorAll('.pm-armra-proof__logos');
    Array.prototype.forEach.call(containers, function (container) {
      if (container.classList.contains('pm-marquee')) return;
      var logos = Array.prototype.slice.call(container.children);
      if (logos.length < 3) return;
      var track = document.createElement('div');
      track.className = 'pm-marquee__track';
      logos.forEach(function (logo) { track.appendChild(logo); });
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      container.appendChild(track);
      container.appendChild(clone);
      container.classList.add('pm-marquee');
    });
  }

  /* ---------- Barra de progreso de scroll (degradado de marca) ---------- */
  var progressBar = null;
  var progressTicking = false;
  function setupScrollProgress() {
    if (document.querySelector('.pm-scroll-progress')) return;
    progressBar = document.createElement('div');
    progressBar.className = 'pm-scroll-progress';
    progressBar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(progressBar);
    updateProgress();
  }
  function updateProgress() {
    progressTicking = false;
    if (!progressBar) return;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? (window.scrollY / h) : 0;
    progressBar.style.transform = 'scaleX(' + Math.min(Math.max(p, 0), 1).toFixed(4) + ')';
  }

  /* ---------- Eyebrows: subrayado que se dibuja al entrar en viewport ---------- */
  function setupEyebrows(root) {
    if (!('IntersectionObserver' in window)) return;
    var sel = '[class*="pm-armra"][class*="__eyebrow"], .pm-armra-faq__intro > p:first-child, .pm-armra-testimonials__header > div > p:first-child, .pm-armra-products__header p:first-child, .pm-armra-news__eyebrow, .pm-armra-audit__eyebrow';
    var nodes = (root || document).querySelectorAll(sel);
    if (!eyebrowObserver) {
      eyebrowObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('pm-uline-in');
            eyebrowObserver.unobserve(e.target);
          }
        });
      }, { threshold: 0.6 });
    }
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.hasAttribute('data-pm-uline')) return;
      el.setAttribute('data-pm-uline', '');
      eyebrowObserver.observe(el);
    });
  }
  var eyebrowObserver = null;

  /* ---------- Init ---------- */
  function init(root) {
    setupMarquee(root);
    setupReveals(root);
    setupEyebrows(root);
    collectParallax(root);
    setupPowder(root);
    updateParallax();
  }

  function onBreakpointChange() {
    // Al cruzar el breakpoint reseteamos el offset (mobile) o lo recalculamos (desktop).
    updateParallax();
  }

  function start() {
    setupScrollProgress();
    init(document);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (desktopMQ.addEventListener) {
      desktopMQ.addEventListener('change', onBreakpointChange);
    } else if (desktopMQ.addListener) {
      desktopMQ.addListener(onBreakpointChange);
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        revealFallbackCheck();
        updateParallax();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Soporte editor de temas */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
